// NPM Imports
import React, { Component, Fragment } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import {
  Loader,
  Toastr,
  Tooltip,
  Button,
  Label,
  Input,
} from "@revvsales/components";
import CreatableSelect from "react-select/lib/Creatable";

import SHIELD from "../../assets/ic-shield.svg";

// Components Imports

// Action Imports
import {
  addAcceptorsDetailsAction,
  updateSharedUsers,
  updateEmailMessage,
  updateVideoUrl,
} from "../../actions/DocumentActions";
import { getAllTeammatesUsersService } from "../../actions/UserActions/userService";
import { removeAttachmentService } from "../../actions/DocumentActions/services";

import { DocumentUtils, GlobalUtils } from "../../utils";

// Destructuring
const { _emailIsValid } = DocumentUtils;
const { isChromeBrowser } = GlobalUtils;

class AddAcceptors extends Component {
  state = {
    sharedUsers: [
      {
        user_email: "",
        first_name: "",
        last_name: "",
        id: 0,
        disabled: false,
        video_kyc: false,
      },
    ],
    errMsg: "",
    showLoader: false,
    showShareBtnLoader: false,
    reviewerEmailMessage: "",
    showLoaderAttachment: false,
    showLoaderClicktoRecord: false,
    isChrome: false,
    userOptions: [],
  };

  componentDidMount() {
    if (this.props.sharedUsersSender.length > 0) {
      this.setState({ sharedUsers: this.props.sharedUsersSender });
    }
    if (this.props.emailMessage && this.props.showEmailMessage) {
      this.setState({ reviewerEmailMessage: this.props.emailMessage });
    }
    if (this.props.showEmailMessage || this.props.videoThumbnail) {
      this.setState({ showLoaderAttachment: true });
    }
    const isChromeVal = isChromeBrowser();
    this.setState({ isChrome: isChromeVal });
    this._fetchTeammates();
  }

  _fetchTeammates = async () => {
    const userData = await getAllTeammatesUsersService();
    if (
      userData.users &&
      Array.isArray(userData.users) &&
      userData.users.length
    ) {
      userData.users.forEach(d => {
        d.value = d.id.toString();
        d.label = d.user_email;
      });
      this.setState({
        userOptions: userData.users,
      });
    }
  };

  _closePopup = () => {
    this.props.updateMultipleState({
      addAcceptorList: false,
      showEmailMessage: false,
    });
    this.setState({ showLoaderAttachment: false });
  };

  // Handle dynamic  Fields
  _handleValue = (e, i, name) => {
    const data = [...this.state.sharedUsers];
    if (name === "user_email") {
      if (e === null) {
        data[i].disabled = false;
        data[i][name] = "";
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";
        this.setState({
          errMsg: "",
        });
      } else {
        data[i].disabled = false;
        data[i][name] = e.label;
        data[i].id = 0;
        data[i].first_name = "";
        data[i].last_name = "";

        if (e.label.length > 0 && _emailIsValid(e.label) === false) {
          data[i].notValid = true;
        } else {
          delete data[i].notValid;
          const stateUser = this.getUserStateData(e.label, i);
          if (stateUser && stateUser.length > 0) {
            this.setState({
              errMsg:
                "You've already added this contact as a recipient. Please click on the (x) button to clear the field and add a new one.",
            });
          } else if (e.label.length > 0 && e.first_name && e.last_name) {
            data[i].disabled = true;
            data[i].id = e.id;
            data[i].first_name = e.first_name;
            data[i].last_name = e.last_name;
            data[i].video_kyc = !!(
              this.props.sharedUsersSender.length > 0 &&
              this.props.sharedUsersSender[i] &&
              this.props.sharedUsersSender[i].video_kyc
            );
            this.setState({
              errMsg: "",
            });
          }
        }
      }
    } else {
      data[i][name] = e.target.value;
    }
    this.setState(() => ({ sharedUsers: data }));
    const status = this._checkFieldsFilled(
      this.state.sharedUsers[this.state.sharedUsers.length - 1],
    );
    if (!status) {
      const payload = {
        sharedUsersSender: this.state.sharedUsers,
      };
      this.props.updateSharedUsers(payload);
    }
  };

  // get users from the state for the validation
  getUserStateData = (email, index) => {
    const value = [];
    for (let i = 0; i < index; i += 1) {
      if (this.state.sharedUsers[i].user_email === email) {
        value.push(email);
      }
    }
    return value;
  };

  // Add more users for the sharing
  _onAddMoreUsers = () => {
    const data = [...this.state.sharedUsers];
    data.push({
      user_email: "",
      first_name: "",
      last_name: "",
      video_kyc: false,
    });
    this.setState(() => ({ sharedUsers: data }));
    const payload = {
      sharedUsersSender: this.state.sharedUsers,
    };
    this.props.updateSharedUsers(payload);
  };

  // Remove the add users from state
  _onRemoveSharedUser = index => {
    const data = [...this.state.sharedUsers];
    data.splice(index, 1);
    this.setState(() => ({ sharedUsers: data, errMsg: "" }));
    const payload = {
      sharedUsersSender: this.state.sharedUsers,
    };
    this.props.updateSharedUsers(payload);
  };

  // After sharing reset the input feilds
  resetItems = () => {
    if (this.state.sharedUsers.length && this.state.sharedUsers.length > 0) {
      this.setState({
        sharedUsers: [],
      });
    }
    this.setState({
      sharedUsers: [
        {
          user_email: "",
          first_name: "",
          last_name: "",
        },
      ],
    });
  };

  _shareDocument = () => {
    this.setState({ showShareBtnLoader: true });
    // const sharedUsersPayload = [...this.state.sharedUsers];
    // sharedUsersPayload.forEach(item => {
    //   delete item.show_video_auth;
    // });
    const payload = {
      acceptors: this.state.sharedUsers,
      email_message: this.state.reviewerEmailMessage,
    };
    if (this.props.attachmentID !== "") {
      payload.attachment_id = this.props.attachmentID;
    }
    // this.props.attachmentId &&

    this.props
      .addAcceptorsDetailsAction(this.props.docID, payload)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Document has been shared successfully.",
          timeout: 2000,
        });
        this.setState({ showShareBtnLoader: false });
        this.resetItems();
        this.props.updateMultipleState({
          addAcceptorList: false,
          showDocAcceptanceUpdateModal: true,
          attachmentID: "",
          videoThumbnail: "",
          showEmailMessage: false,
        });
        const payloadData = {
          sharedUsersSender: [],
        };
        this.props.updateSharedUsers(payloadData);
        this.props.updateEmailMessage("");
        this.props.updateVideoUrl("");
      })
      .catch(error => {
        this.setState({ showShareBtnLoader: false });
        console.error("DocSharingPopup => shareDocument : Error", error);
      });
  };

  // Check all the fields are filled for current user
  _checkFieldsFilled = data => {
    if (
      data.user_email === "" ||
      data.first_name === "" ||
      data.last_name === "" ||
      data.notValid === true
    ) {
      return true;
    }

    return false;
  };

  // Disbales/enables Add more button and send for acceptance button based on fields data
  _updateButtonStatus = () => {
    const { sharedUsers } = this.state;
    let status = false;
    if (sharedUsers.length > 0) {
      status = this._checkFieldsFilled(sharedUsers[sharedUsers.length - 1]);
    }
    return status;
  };

  _editDocumentUpdate = () => {
    this.props.editDocument(this.props.docID);
    this.props.closePopup();
  };

  _changeReviewMessage = e => {
    this.setState({ reviewerEmailMessage: e.target.value });
  };

  //   showMenu = (event, i) => {
  //   event.preventDefault();
  //   let data = [];
  //   data = [...this.state.signersList];
  //   data[i].showAuth = !data[i].showAuth;
  //   // data[i].showOtp = false;
  //   this.setState(() => ({ signersList: data }));
  // };

  _toggleCheckbox = i => {
    let data = [];
    data = [...this.state.sharedUsers];
    data[i].video_kyc = !data[i].video_kyc;
    data[i].video_kyc = !!data[i].video_kyc;
    this.setState(() => ({ sharedUsers: data }));
    const payload = {
      sharedUsersSender: this.state.sharedUsers,
    };
    this.props.updateSharedUsers(payload);
  };

  _initiateRecordVideo = () => {
    this.setState({ showLoaderClicktoRecord: true });
    this.props.updateEmailMessage(this.state.reviewerEmailMessage);
    this.props.updateMultipleState({
      showEmailMessage: true,
    });
    // eslint-disable-next-line no-new
    new Promise(() => {
      navigator.mediaDevices
        .getUserMedia({
          video: true,
          audio: true,
        })
        .then(() => {
          this.setState({ showLoaderClicktoRecord: false });
          this.props.updateMultipleState({
            addAcceptorList: false,
            toggleRecordVideoPopup: true,
          });
        })
        .catch(() => {
          this.setState({ showLoaderClicktoRecord: false });
          this.props.updateMultipleState({
            addAcceptorList: false,
            showAllowCameraPopup: true,
          });
        });
      // this.props.updateMultipleState({
      //   addAcceptorList: false,
      //   toggleRecordVideoPopup: true,
      // });
    });
  };

  _openPlayback = () => {
    this.props.updateMultipleState({
      addAcceptorList: false,
      toggleRecordVideoPopup: true,
    });
  };

  _removeAttachedVideo = () => {
    this.setState({
      showLoaderAttachment: false,
    });
    removeAttachmentService(this.props.attachmentID, this.props.docID);
    this.props.updateVideoUrl("");
    this.props.updateMultipleState({
      videoThumbnail: "",
      attachmentID: "",
    });
  };

  _renderThumbnail = flag => {
    if (flag) {
      return (
        <div className="show-thumbnail-recordvideo">
          <div className="thumbnail-recordvideo">
            {this.props.videoThumbnail ? (
              <div
                onClick={this._openPlayback}
                onKeyPress={() => {}}
                role="button"
                tabIndex="0"
                data-test="addacceptors-open-playack"
                className="open-playback">
                <FontAwesomeIcon
                  className="open-playback-icon"
                  icon={["fas", "play-circle"]}
                  color="white"
                  size="2x"
                />
                <img
                  src={this.props.videoThumbnail}
                  alt="thumbnail"
                  width="135"
                  height="100"
                />
              </div>
            ) : (
              <Loader />
            )}
          </div>
          <div className="remove-thumbnail-recordvideo">
            <Button
              onClick={e => this._removeAttachedVideo(e)}
              onKeyPress={() => {}}
              type="button"
              tabIndex="0"
              data-test="remove-thumbnail-recordvideo"
              className="btn btn-transparent">
              <FontAwesomeIcon icon={["far", "trash-alt"]} /> Remove Video
            </Button>
          </div>
        </div>
      );
    }
    return <div className="show-thumbnail-recordvideo">Loading....</div>;
  };

  _getValue = data => {
    const returnValue = {};
    if (data) {
      returnValue.label = data;
      returnValue.value = data;
    }
    return returnValue;
  };

  render() {
    const { isChrome } = this.state;
    // console.error(this.props.videoThumbnail, "thumbnail");
    const errMsgSpace =
      this.state.errMsg !== "" ? (
        <div
          className="error-message-wrapper docsharingpopup-errormg-wrapper"
          data-test="doc-sharing-popup-error-message">
          {this.state.errMsg}
        </div>
      ) : null;
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {this.state.showLoader && <Loader className="saving-document" />}
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div
            className="modal-heading"
            data-test="addrecipientspopup-modal-heading">
            Recipient Details
          </div>

          {errMsgSpace}

          <div className="docsharingpopup-sharingform-title">
            Add names and email addresses of recipients whose consent you need.
            They will receive an email with the document link, requesting them
            to Accept or Reject it.
          </div>
          <div className="docsharingpopup-sharing-form-wrapper">
            {/* <div className="docsharingpopup-sharingform-row form-row">
              <div className="col-md-5 docsharingpopup-sharingform-col">
                <Label>Recipients email</Label>
              </div>
              <div className="col-md-3 docsharingpopup-sharingform-col">
                <Label>First name</Label>
              </div>
              <div className="col-md-3 docsharingpopup-sharingform-col">
                <Label>Last name</Label>
              </div>

              <div className="col-md-1 docsharingpopup-sharingform-col" />
            </div> */}
            {this.state.sharedUsers.map((data, i) => (
              <Fragment>
                <div className="docsharingpopup-sharingform-row form-row">
                  <div
                    className="col-md-5 docsharingpopup-sharingform-col"
                    data-test="docsharing-popup-user-email">
                    <Label>
                      Recipients email
                      <span className="required-input" />
                    </Label>
                    <CreatableSelect
                      formatCreateLabel={userInput =>
                        `+ Add "${userInput.toLowerCase()}"`
                      }
                      placeholder="Email here"
                      className={
                        data.notValid ? "not-valid-email-acceptors" : ""
                      }
                      onChange={e => this._handleValue(e, i, "user_email")}
                      options={this.state.userOptions}
                      value={
                        this._getValue(data.user_email).label
                          ? this._getValue(data.user_email)
                          : ""
                      }
                      isClearable={this._getValue(data.user_email).label}
                      data-test="docsharing-popup-user-email"
                      autoFocus
                    />
                  </div>
                  <div className="col-md-3 docsharingpopup-sharingform-col">
                    <Label>
                      First name
                      <span className="required-input" />
                    </Label>
                    <Input
                      type="text"
                      disabled={data.disabled}
                      value={data.first_name}
                      placeholder="First name"
                      data-test="docsharing-user-firstname"
                      onChange={e => this._handleValue(e, i, "first_name")}
                    />
                  </div>
                  <div className="col-md-3 docsharingpopup-sharingform-col">
                    <Label>
                      Last name
                      <span className="required-input" />
                    </Label>
                    <Input
                      type="text"
                      disabled={data.disabled}
                      value={data.last_name}
                      placeholder="Last name"
                      data-test="docsharing-user-lastname"
                      onChange={e => this._handleValue(e, i, "last_name")}
                    />
                  </div>
                  <div className="col-md-1 docsharingpopup-sharingform-col docrecipient-video-auth">
                    {this.state.sharedUsers.length > 1 && (
                      <span
                        className="btn-icon"
                        onClick={() => this._onRemoveSharedUser(i, data)}
                        onKeyPress={() => {}}
                        role="button"
                        data-test="docsharing-user-delete"
                        tabIndex="0">
                        <FontAwesomeIcon icon={["far", "trash-alt"]} />
                      </span>
                    )}
                  </div>
                  <div className="documentrecipientlist-oauth-wrapper">
                    <Fragment>
                      <div className="documentrecipientlist-otp-wrapper">
                        <div className="documentrecipientlist-userprofile-wrapper">
                          <div className="documentrecipientlist-profile-wrapper">
                            <span className="documentrecipientlist-profile-name">
                              <span className="documentrecipientlist-profile-email">
                                Enable recipient verification by video KYC
                                <span className="sign-auth esign-authen-icon" />
                              </span>
                            </span>

                            <span className="documentrecipientlist-profile-email esign-show-otp">
                              <Input
                                data-test="confirmationbox-template-delete-checkbox-input"
                                type="checkbox"
                                value=""
                                checked={data.video_kyc}
                                onChange={() => this._toggleCheckbox(i)}
                              />

                              <Label
                                className="esign-authen-icon"
                                htmlFor="documentdelete-checkbox"
                                data-test="esignotp-checkbox-label">
                                Request recipients to record a video to accept
                                the document{" "}
                                <Tooltip
                                  placement="right"
                                  overlay="This is a digital recipient identity verification process for enhanced security. Recipients will be required to record a video of self stating they accept this document."
                                  align={{
                                    offset: [6, 0],
                                  }}>
                                  <span className="btn-icon">
                                    <FontAwesomeIcon
                                      icon={["far", "info-circle"]}
                                    />
                                  </span>
                                </Tooltip>
                              </Label>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  </div>
                </div>
              </Fragment>
            ))}
            <div className="docsharingpopup-sharingform-footer">
              <div className="docsharingpopup-addmoreuser-btn">
                <Tooltip placement="right" overlay="Add more users">
                  <Button
                    disabled={this._updateButtonStatus()}
                    type="two"
                    data-test="docsharing-popup-add-btn"
                    onClick={this._onAddMoreUsers}>
                    <i className="plusiconadd">
                      <FontAwesomeIcon icon={["far", "plus"]} className="" />{" "}
                    </i>
                    &nbsp; Add recipient
                  </Button>
                </Tooltip>
              </div>
            </div>
          </div>
          <hr />

          <p>
            Personalize the email by adding a text or video message from you
          </p>

          <div className="acceptors-note-wrapper">
            <div className="docsharing-reviewer-email-acceptor">
              <textarea
                placeholder="Start typing your message here"
                value={this.state.reviewerEmailMessage}
                onChange={e => this._changeReviewMessage(e)}
                data-test="docsharing-reviewer-email-acceptor"
              />
            </div>

            {this.state.showLoaderAttachment ? (
              this._renderThumbnail(this.state.showLoaderAttachment)
            ) : (
              <div className="attach-video">
                <div className="attach-video-main">
                  <FontAwesomeIcon icon={["fal", "video"]} size="3x" />
                  <p className="attachvideo-subhead">
                    Attach video message with email.
                  </p>
                </div>
                {!isChrome ? (
                  <div className="attach-video-main">
                    <span>
                      <FontAwesomeIcon
                        icon={["fas", "info-circle"]}
                        color="red"
                      />
                    </span>
                    <p className="attachvideo-text">
                      Video recording will soon be available on this browser.
                      For now, please try this feature on Google Chrome.
                    </p>
                  </div>
                ) : (
                  <Button
                    isLoading={this.state.showLoaderClicktoRecord}
                    disabled={this.state.showLoaderClicktoRecord}
                    className="click-to-record"
                    type="two"
                    data-test="docsharing-popup-add-btn"
                    onClick={e => this._initiateRecordVideo(e)}>
                    Click to record
                  </Button>
                )}
                {isChrome && (
                  <p className="attachvideo-text">
                    <FontAwesomeIcon icon={["far", "info-circle"]} /> Give Revv
                    permission to use your systems camera and mic in the next
                    step for video recording.
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="emptysigner-popup-warning-section">
            <div>
              <img src={SHIELD} alt="Revv" className="legal-signer-icon" />
            </div>
            <div>
              {/* <div className="emptysigner-popup-legal-title">
                Legal, secure, reliable
              </div> */}
              <div className="emptysigner-popup-legal-subtitle">
                Revv complies with the highest level of safety standards and has
                tight data security measures. Your document and video are
                completely safe and will not be misused in any manner.
              </div>
            </div>
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              id="addrecipientspopup-cancle-btn"
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="addrecipientspopup-cancle-btn"
              onClick={this._editDocumentUpdate}>
              Edit document
            </Button>
            {this._updateButtonStatus() === true ? (
              <Tooltip
                placement="bottom"
                align={{
                  offset: [0, 4],
                }}
                overlay="Add recipient details to send document">
                <div className="tooltip-allowed">
                  <Button
                    isLoading={this.state.showShareBtnLoader}
                    data-test="docsharing-popup-share-btn"
                    disabled={this._updateButtonStatus()}
                    className="btn btn-success docsharingpopup-sharebtn"
                    onClick={() => this._shareDocument()}>
                    Send for acceptance
                  </Button>
                </div>
              </Tooltip>
            ) : (
              <Button
                isLoading={this.state.showShareBtnLoader}
                data-test="docsharing-popup-share-btn"
                className="btn btn-success docsharingpopup-sharebtn"
                onClick={() => this._shareDocument()}>
                Send for acceptance
              </Button>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { sharedUsers, users } = state.SharedDocument;
  const { sharedUsersSender, emailMessage } = state.DocumentStore;
  return {
    sharedUsers,
    sharedUsersSender,
    users,
    emailMessage,
  };
};

const mapDispatchToProps = {
  addAcceptorsDetailsAction,
  updateSharedUsers,
  updateEmailMessage,
  updateVideoUrl,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddAcceptors);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddAcceptors.js